import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type ContactsComparisonTableStore } from 'pages/analytics/pages/contacts/store/contactsAnalyticsPageStore'
import { getColumns } from './getColumns'

interface IContactsComparisonTableProps {
  store: ContactsComparisonTableStore
}

export const ContactsComparisonTable = observer(({ store }: IContactsComparisonTableProps) => {
  const { tableStore, comparisonRows, breakdownFilterType } = store

  const columns = useMemo(() => getColumns(breakdownFilterType), [breakdownFilterType])

  return (
    <Table
      ariaLabel={'ContactsComparisonTable'}
      store={tableStore}
      columns={columns}
      rows={comparisonRows}
      hidePagination={true}
      emptyStateProps={{
        text: 'No comparison data found',
        noIcon: true,
      }}
      scrollbarProps={{
        autoHeight: true,
        height: 'auto',
        autoHeightMax: 600,
      }}
    />
  )
})
